import { render, staticRenderFns } from "./FairModal.vue?vue&type=template&id=e6a8ba20"
import script from "./FairModal.vue?vue&type=script&lang=js"
export * from "./FairModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports